import React, { Fragment } from 'react'
import { SortableTableHeader } from '../../../../app/components/statelessDataTable/components/tableColumn'
import { StyledLink } from '../../../../theme/Global'
import { COMMON_TABLE_HEADERS } from '../../../../common/constants'
import { NS_NULL_VALUE } from '../../../../app/constants'

const paidLeaveNotificationsAddressColumns = ({
  sortOptions,
  eventHandlers
}) => {
  const columns = [
    {
      Header: () => (
        <SortableTableHeader
          {...{
            field: 'displayName',
            text: COMMON_TABLE_HEADERS.LOCATION_NAME,
            sortOptions,
            eventHandlers
          }}
        />
      ),
      accessor: 'displayName',
      width: 200,
      minWidth: 0, // default
      maxWidth: 0, // default
      Cell: ({ cell }) => (
        <StyledLink to={`/paidLeave/details/${cell.row.original._id}`}>
          {cell.row.original.name}
        </StyledLink>
      ),
      canSort: true
    },
    {
      Header: COMMON_TABLE_HEADERS.ADDRESS,
      accessor: 'address',
      width: 200,
      minWidth: 0, // default
      maxWidth: 0, // default
      Cell: ({ cell }) => createAddressCell(cell.row.original.address),
      canSort: false
    }
  ]
  return columns
}

export default paidLeaveNotificationsAddressColumns

const createAddressCell = ({
  addressOne,
  addressTwo,
  addressThree,
  city,
  stateCode,
  zip,
  shipAttention
}) => {
  return (
    <Fragment>
      <div className="text">{addressOne}</div>
      {addressTwo && addressTwo !== NS_NULL_VALUE ? (
        <div className="text">{addressTwo}</div>
      ) : null}
      {addressThree && addressThree !== NS_NULL_VALUE ? (
        <div className="text">{addressThree}</div>
      ) : null}
      <div className="text">
        {`${city}, ${stateCode} ${zip}`}
      </div>
      <div className="text">
        {shipAttention ? `Attn: ${shipAttention}` : null}
      </div>
    </Fragment>
  )
}
